import { useEffect } from 'react'

import { HOME_ID } from './context'
import type { CommandPaletteSection } from './types'
import { useCommandPalette } from './use-command-palette'

/** domain-side hook: register a section with the palette while this hook is
 * mounted, unregister on unmount. callers should memoize the section so the
 * effect only re-fires when something content-meaningful changes (e.g. a
 * badge count). reserved id 'home' is rejected.
 */
export function useRegisterPaletteSection(section: CommandPaletteSection) {
  const { registerSection, unregisterSection } = useCommandPalette()

  useEffect(() => {
    if (section.id === HOME_ID) {
      throw new Error(`section id '${HOME_ID}' is reserved`)
    }
    registerSection(section)
    return () => unregisterSection(section.id)
  }, [registerSection, unregisterSection, section])
}
